module.exports = __webpack_public_path__ + "img/MAIL.fe6e65b7.svg";